import React, { useEffect } from 'react';

import { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { SortDescriptor } from 'utils/dataQuery';
import { FieldSettings } from 'utils/dataQuery';
import { useIntl } from 'react-intl';
import { User } from 'apis/UsersApi';

interface UserGMetrixTableProps<T> {
    advancedSearchFields: FieldSettings[];
    allowExport?: boolean;
    columnData: GMetrixTableColumnProps<User>[];
    defaultItemsPerPage?: number;
    getAllUsers: (partnerId: number) => void;
    initialSkip?: number;
    loadingGridData: boolean;
    manuallyRenderUsers?: boolean;
    onDetailsItemClick?: (dataItem: User) => Promise<void> | undefined;
    onExportAllData?: () => Promise<User[]>;
    onServerPageChange?: (skip: number, take: number) => void;
    onServerSortChange?: (sort: SortDescriptor[]) => void;
    partnerId?: number;
    searchAutoFocus?: boolean;
    searchTerm: string;
    serverSidePagination?: boolean;
    serverTotalCount?: number;
    setLoadingGridData: React.Dispatch<React.SetStateAction<boolean>>;
    setSearchTerm: (searchTerm: string) => void;
    setUsers: (users: User[]) => void;
    toggleColumns?: boolean;
    users: User[];
    viewPermission: boolean;
}

export function UserGMetrixTable<T>({
    allowExport = false,
    columnData,
    defaultItemsPerPage,
    getAllUsers,
    initialSkip,
    loadingGridData,
    manuallyRenderUsers = false,
    onDetailsItemClick,
    onExportAllData,
    onServerPageChange,
    onServerSortChange,
    partnerId,
    searchAutoFocus,
    searchTerm,
    serverSidePagination = false,
    serverTotalCount,
    setLoadingGridData,
    setSearchTerm,
    toggleColumns,
    users,
    viewPermission
}: UserGMetrixTableProps<T>) {

    const { formatMessage } = useIntl();

    useEffect(() => {

        if (!manuallyRenderUsers) {

            getAllUsers(partnerId ? partnerId : -1);

        }

    }, []);

    useEffect(() => {

        if (searchTerm.length > 0 && users.length === 0 && loadingGridData) {

            setLoadingGridData(false);

        }

    }, [searchTerm, users, loadingGridData]);

    return (
        <GMetrixTable
            rowData={users.map(user => {

                //Didn't want to do this but GMetrixTable isn't liking passing PartnerList[0].Active as column so I made a property on the rool level.
                user.PartnerActive = user.PartnerList?.[0]?.Active ?? user.PartnerActive;
                user.PartnerInviteText = user.PartnerList?.[0]?.InviteStatusText ?? '';

                if (!viewPermission) {

                    user.DisabledDetailsBtn = true;

                }
                return user;

            })}
            allowExport={allowExport}
            bottomBarTableName={formatMessage({ id: 'users.581e673f', defaultMessage: 'Users' })}
            columnData={columnData}
            defaultItemsPerPage={defaultItemsPerPage}
            excelExportFileName={formatMessage({ id: 'userlist.d6cd8857', defaultMessage: 'UserList' })}
            initialSkip={initialSkip}
            loading={loadingGridData}
            onDetailsItemClick={onDetailsItemClick}
            onExportAllData={onExportAllData}
            onServerPageChange={onServerPageChange}
            onServerSortChange={onServerSortChange}
            searchAutoFocus={searchAutoFocus}
            searchPlaceholder={formatMessage({ id: 'search_users_by_name_email_or_username.d5f756e1', defaultMessage: 'Search users by name, email, or username...' })}
            searchTerm={searchTerm}
            selectableRows={false}
            selected={[]}
            serverSidePagination={serverSidePagination}
            serverTotalCount={serverTotalCount}
            setSearchTerm={setSearchTerm}
            toggleColumns={toggleColumns}
        />
    );

}
